import { render, staticRenderFns } from "./YpoPhoneNumber.vue?vue&type=template&id=444593cc&"
import script from "./YpoPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./YpoPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./YpoPhoneNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports